// docu is available here https://docs.usercentrics.com/#/browser-cmp

import { isDefined } from 'utils/helper/common';

export enum ConsentService {
  SENTRY = 'Sentry for app.collabary.com',
  INSTAGRAM = 'Instagram for app.collabary.com',
  TIKTOK = 'TikTok for app.collabary.com',
  YOUTUBE = 'YouTube for app.collabary.com'
}

const TemplateIds = {
  [ConsentService.INSTAGRAM]: '',
  [ConsentService.YOUTUBE]: '',
  [ConsentService.TIKTOK]: ''
};

const UCReloadEventActions = ['onUpdateServices', 'onDenyAllServices', 'onAcceptAllServices'];

interface UCGenericEvent {
  detail: {
    action: string
  }
}

// allow custom events
declare global {
  interface WindowEventMap {
    'ucConsentEvent': UCGenericEvent
  }
}

window.addEventListener('ucConsentEvent', (e: UCGenericEvent) => {
  if (UCReloadEventActions.includes(e.detail.action)) {
    // reload on consent change
    setTimeout(() => window.location.reload(), 500);
  }
});

function collectTemplateIds() {
  const consents = window.UC_UI?.getServicesBaseInfo();
  const templateIdKeys = Object.keys(TemplateIds);
  consents?.forEach((service) => {
    if (templateIdKeys.includes(service.name)) {
      TemplateIds[service.name] = service.id;
    }
  });
}

export function allowSocialNetworks() {
  if (typeof window.UC_UI?.updateServices === 'function') {
    window.UC_UI?.updateServices(
      Object.values(TemplateIds)
        .filter(isDefined)
        .map(serviceId => ({ serviceId, status: true }))
    );
  } else {
    const ucElement = document.querySelector('ul.footer__nav a[href="#uc-central-modal-show"]');

    if (ucElement === null) {
      return;
    }

    ucElement.dispatchEvent(new Event('click', { bubbles: true }));
  }
}

export function waitForUsercentrics(): Promise<boolean> {
  return new Promise<boolean>((resolve) => {
    if (window.UC_UI?.isInitialized()) {
      collectTemplateIds();
      resolve(true);
      return;
    }

    let checkTimeout;

    const checkInterval = window.setInterval(() => {
      if (window.UC_UI?.isInitialized()) {
        clearTimeout(checkTimeout);
        clearInterval(checkInterval);
        collectTemplateIds();
        resolve(true);
      }
    }, 250);

    checkTimeout = setTimeout(() => {
      window.clearInterval(checkInterval);
      resolve(false);
    }, 10 * 1000);
  });
}

// similar logic is used in tracking library
export async function getConsentAsync(service: ConsentService): Promise<boolean> {
  const hasUC = await waitForUsercentrics();
  if (!hasUC) {
    return false;
  }

  return window.UC_UI
    ?.getServicesBaseInfo()
    .find((consent) =>
      consent.name === service
    )
    ?.consent?.status ?? false;
}

export function triggerConsentPanel() {
  window.UC_UI?.showFirstLayer();
}

export function triggerConsentPreferencesDialog() {
  window.UC_UI?.showSecondLayer();
}
